export default __webpack_public_path__ + "static/media/notfound.c824abdd.jpg";